import BillingDetails from './BillingDetails/BillingDetails.vue';
import OrderOverview from './OrderOverview/OrderOverview.vue';
import ServerError from 'presentation/components/ServerError/ServerError.vue';
import { shallowRef, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import useCart from 'hooks/useCart';
import useCartTools from 'hooks/useCartTools';
import useQuoteTools from 'hooks/useQuoteTools';

export default {
  components: {
    // CheckoutTopSection,
    OrderOverview,
    BillingDetails,
    ServerError,
  },
  data: ()=>({isQuoteOrderFlow: false}),
  mounted(){
    // this.$root.$on("onSubscriptionDetailsSelect", (subDetails) => {
    //   this.subscriptionDetails = subDetails;
    // });
    if(this.$route.query.stage && this.$route.query.stage === "orderQuote"){
      this.isQuoteOrderFlow = true;
    } else if(this.$route.query.flow && this.$route.query.flow === "checkout") {
      this.isQuoteOrderFlow = true;
    } else {
      this.isQuoteOrderFlow = false;
    }
  },
  setup() {
    const subscriptionDetails = shallowRef(null);
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const shippingMethod = shallowRef(null);
    const validBillingForm = shallowRef(false);
    const validShippingForm = shallowRef(true);
    const paymentMethod = shallowRef('card');
    const showError = shallowRef(false);
    const error = shallowRef(null);
    const { cart, loading } = useCart();
    const billingAddress = shallowRef(null);
    const shippingAddress = shallowRef(null);
    const cartTools = useCartTools();
    const quoteTools = useQuoteTools();
    const quoteComment = shallowRef(null);
    const isCreateQuoteRequest = shallowRef(false);
    //@todo: what happened to the payment method passed to this?
    const placeOrder = () => {
      if (!validBillingForm.value) {
        showError.value = true;
        return Promise.resolve();
      }
      showError.value = false;
      return cartTools
        .setAddressForCart({
          billingAddress,
          shippingAddress,
          subscriptionDetails
        })
        .then(() => {
          if((router.currentRoute.value.query.stage && router.currentRoute.value.query.stage === 'orderQuote')) {
            router.push({
              name: 'pay',
              params: { method: paymentMethod.value, quoteId:  route.query.quoteId, quoteVersion: route.query.quoteVersion, requestId: route.query.requestId, requestVersion: route.query.requestVersion},
            });
          } else if(router.currentRoute.value.query.flow && router.currentRoute.value.query.flow === 'checkout'){
            router.push({
              name: 'pay',
              params: { method: paymentMethod.value },
            });
          } else {
            isCreateQuoteRequest.value = true;
          }
        })
        .catch((e) => {
          error.value = e;
        });
    };
    const quoteRequestSuccessCallback = (quote) => {
      // console.log(quote, "Callback")
      router.push({
        name: 'quoteConfirmation',
        params: { id: quote?.createMyQuoteRequest?.id },
      });
    }
    watch([cart, loading], ([cart, loading]) => {
     if(isCreateQuoteRequest.value == true) {
      quoteTools.createQuoteRequest(cart, quoteComment.value, quoteRequestSuccessCallback)
      isCreateQuoteRequest.value=false
     }
     if(cart && !loading && route.query.stage === 'orderQuote') {
      if(cart.billingAddress) {
        // eslint-disable-next-line no-unused-vars
        const { ['__typename']: excludeBillingProperty, ...restBillingAddress } = cart.billingAddress;
        billingAddress.value = restBillingAddress
      }
      
      if(cart.shippingAddress) {
        // eslint-disable-next-line no-unused-vars
        const { ['__typename']: excludeShippingProperty, ...restShippingAddress } = cart.shippingAddress;
        shippingAddress.value = restShippingAddress;
      }
     }
      if (!cart && !loading) {
        router.replace({ path: '/' });
      }
    });
    const setValidBillingForm = (valid) => {
      validBillingForm.value = valid;
    };
    const setValidShippingForm = (valid) => {
      validShippingForm.value = valid;
    };
    const updateBilling = (billingDetails) => {
      billingAddress.value = JSON.parse(
        JSON.stringify(billingDetails)
      );
    };
    const updateShipping = (shippingDetails) => {
      shippingAddress.value = JSON.parse(
        JSON.stringify(shippingDetails)
      );
    };
    const updateShippingMethod = (shippingId) => {
      shippingMethod.value = shippingId;
    };
    const paymentChanged = (payment) => {
      paymentMethod.value = payment;
    };

    const setSubscriptionDetails = (details) => {
      if(details.frequency && details.day) {
        subscriptionDetails.value = {
          isSubscribed: true,
          frequency: details.frequency,
          date: details.day
        }
      } else {
        subscriptionDetails.value = {
          isSubscribed: false
        }
      }
    }

    return {
      ...cartTools,
      placeOrder,
      shippingMethod,
      billingAddress,
      shippingAddress,
      validBillingForm,
      validShippingForm,
      showError,
      setValidBillingForm,
      setValidShippingForm,
      updateBilling,
      updateShipping,
      updateShippingMethod,
      paymentMethod,
      paymentChanged,
      subscriptionDetails,
      error,
      cart,
      t,
      setSubscriptionDetails,
      quoteComment
    };
  },
};
